// Indica se a empresa logada contratou o módulo CFP - Cajupe Folha de Pagamento. Sem ele, as telas
// compartilhadas (como as verbas da folha) seguem o comportamento de antes.
export default {
  computed: {
    calculoFolhaContratado() {
      const modulos = this.$store.state?.inquilino?.modulosContratacao || [];
      return modulos.some((m) => m?.tipo === "CFP" && m?.ativo !== false);
    },
  },
};
